export const HIDE_SNACKBAR_POSITION = 55;
export const SHOW_SNACKBAR_POSITION = 0;

export const LENGTH_INDEFINITE = -1;
export const LENGTH_SHORT = 1000;
export const LENGTH_LONG = 3000;
export const LENGTH_LONGEST = 5000;
